import { render, staticRenderFns } from "./ProductModelShowScreen.vue?vue&type=template&id=5a6c9563&"
import script from "./ProductModelShowScreen.vue?vue&type=script&lang=js&"
export * from "./ProductModelShowScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports